import React from 'react'
import { FightPlayerItem } from 'web/containers/shared/FightPlayerItem'
import { FightSetup, FullFight } from 'web/data/models'
import { sortPlayers } from 'web/utils/sort-utils'

type Props = {
    fullFight: FullFight
    selectedSetup?: FightSetup
}

export const DisplayFightSidebar: React.FC<Props> = ({
    fullFight,
    selectedSetup
}) => {

    const playerElements: JSX.Element[] = []

    if (selectedSetup) {
        const fightPlayers = [...selectedSetup.fightPlayers].sort(sortPlayers)

        fightPlayers.forEach(player => {
            playerElements.push(
                <FightPlayerItem
                    key={player.id}
                    interactive={false}
                    fightPlayer={player}
                    setup={selectedSetup}
                    fullFight={fullFight}
                />
            )
        })
    }

    if (selectedSetup == null) {
        return (
            <div
                style={{ width: "282px" }}
            >
                <div className="d-flex small text-muted p-3 text-center align-items-center font-italic">
                    {"Players you add to the current setup will be listed here, start by creating a new setup."}
                </div>
            </div>
        )
    }

    return (
        <div
            className="d-flex flex-column space-my-3"
            style={{ width: "282px" }}
        >

            {playerElements.length <= 0 &&
                <div className="d-flex small text-muted p-3 text-center align-items-center font-italic">
                    {"Players you add to the current setup will be listed here."}
                </div>
            }

            {playerElements.length >= 1 &&
                <div className="d-flex flex-column space-my-3">
                    {playerElements}
                </div>
            }

        </div>
    )
}
